export default __webpack_public_path__ + "img/list7.579b358f.jpeg";